"use client";

import GreenCheck from "assets/svg/green-check-circle.svg";

import styles from "./styles.module.css";

const ResultScreen = () => {
  return (
    <div className={styles.resultWrap}>
      <div className={styles.resultIconWrap}>
        <GreenCheck />
      </div>
      <h1 className={styles.title}>Teşekkürler!</h1>
      <span className={styles.subInfo}>Şikayetinizle ilgili gelişmelerden sizi haberdar edeceğiz.</span>
    </div>
  );
};

export default ResultScreen;
